import { render, staticRenderFns } from "./PopularTour.vue?vue&type=template&id=50138d06&scoped=true&"
import script from "./PopularTour.vue?vue&type=script&lang=js&"
export * from "./PopularTour.vue?vue&type=script&lang=js&"
import style0 from "./PopularTour.vue?vue&type=style&index=0&id=50138d06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50138d06",
  null
  
)

export default component.exports